import React, { useRef, useState, useEffect } from "react";
import {
  Fieldset,
  Legend,
  InputSelect,
  Option,
  Label,
  StyledSelect,
  SelectedLabel,
} from "./styled";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import ValidationBar from "../common3/ValidationBar";
import HelpIcon from '../common3/HelpBox/Icon'
import HelpBox from "../common3/HelpBox";

const Dropdown = (props) => {
  const {
    extra = {},
    value = null,
    save = () => { },
    id,
    runEffect,
    effects = {},
    formData,
    validationError = {},
    disableValidation,
    dispatchEvent,
    htmlTemplates = {}
  } = props;
  const {
    label = "",
    options = [],
    subLabel = "",
    optionsType = "static",
    effects: extraEffects,
    helpBoxAlwaysVisible = false,
    helpBoxIcon = false,
    helpBoxTemplateId = null,
    helpBoxTemplate = null,
    validation = {}
  } = extra;

  const disabled = props.disabled || extra.disabled;

  const { required = false } = validation

  const [selectedValue, setSelectedValue] = useState(value);
  const [selectedLabel, setSelectedLabel] = useState(label);
  const [focused, setFocused] = useState(false);
  const [helpBoxOpen, setHelpBoxOpen] = useState(helpBoxAlwaysVisible ? true : false)

  let selectToDisplay = null; // The value to render

  /**
   * MOUNT: Check for default values
   */
  useEffect(() => {
    if (value === null && (optionsType === 'static' || optionsType === 'advanced')) {
      let newValue = null;
      options.forEach((o) => {
        if (o.setDefault) {
          newValue = o.value ? o.value : o.label;
        }
      });
      setSelectedValue(newValue);
    }
  }, []);

  /**
   * LOAD
   */
  useEffect(() => {
    if (
      (optionsType === "effects" || optionsType === "register") &&
      !isEmpty(extraEffects)
    ) {
      runEffect({ source: extraEffects, effectId: id });
    }
  }, [id, optionsType, options, runEffect, formData, extraEffects]);

  /**
   * selectToDisplay
   *
   * Check if we are effect or register, then we pick from props.effects (if not we pick from options)
   */
  if (
    (optionsType === "effects" || optionsType === "register") &&
    !isEmpty(extraEffects)
  ) {
    selectToDisplay = get(effects, [id], null);
  } else {
    selectToDisplay = options;
  }

  /**
   * Validation checks
   *
   * TODO: make re-usable effect
   */
  let error = validationError.critical ? "critical" : null;
  let errorMessage = validationError.critical;
  if (!error) {
    error = validationError.error ? "danger" : null;
    errorMessage = validationError.error;
  }
  if (!error) {
    error = validationError.warning ? "warning" : null;
    errorMessage = validationError.warning;
  }

  useEffect(() => {
    if (!selectedValue) {
      setSelectedLabel(label);
      return;
    }

    if (selectToDisplay) {
      // setSelectedLabel(selectToDisplay.find( ({ value,label }) => value ? value === selectedValue : label === selectedValue ).label)
      const foundToDisplay = selectToDisplay.find((line) => {
        let { value, label } = line;
        if (typeof line === "string") {
          label = line;
          value = line;
        }
        return value ? value === selectedValue : label === selectedValue;
      });
      setSelectedLabel(
        foundToDisplay && foundToDisplay.label
          ? foundToDisplay.label
          : foundToDisplay
      );
    }
  }, [selectedValue, selectToDisplay, label]);

  /**
   * SAVE EFFECT
   */
  const didMountRef = useRef(false);
  useEffect(() => {
    if (didMountRef.current) {
      if (selectToDisplay) {
        // find the line
        const context = selectToDisplay.find((f) => f.value === selectedValue);

        save({ key: id, value: selectedValue, context });
        dispatchEvent("onChange");
      }
    } else {
      didMountRef.current = true;
    }

    // including save will loop the component
  }, [selectedValue, id]);

  /**
   * Ensure taht selectToDisplay is array, if selectToDisplay === null then we are waiting for data
   */
  if (!Array.isArray(selectToDisplay)) {
    return null;
  }

  const _helpBoxTemplate = helpBoxTemplateId === '_custom' ? helpBoxTemplate : get(htmlTemplates, [helpBoxTemplateId, 'html'], '')

  return (
    <React.Fragment>
      {
        !helpBoxAlwaysVisible && helpBoxIcon && <HelpIcon toggle={() => setHelpBoxOpen(!helpBoxOpen)} />
      }
      <Fieldset focus={focused} error={error} disabled={disabled} className={required ? 'sp-required' : ''}>
        <Legend focus={focused} labelSelected={selectedLabel === label} aria-hidden="true">
          {(focused || selectedLabel !== label) && label}
        </Legend>
        <Label
          selectedValue={selectedValue}
          focus={focused}
          labelSelected={selectedLabel === label}
          error={error}
          disabled={disabled}
        >
          {label}
        </Label>
        <InputSelect
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => {
            setSelectedValue(e.target.value);
          }}
          disabled={disabled}
        >
          <Option value=""></Option>
          {selectToDisplay &&
            selectToDisplay.map((line, i) => {
              let { label, value } = line;

              if (typeof line === "string") {
                label = line;
                value = line;
              }

              return (
                <Option key={i} value={value ? value : label}>
                  {label}
                </Option>
              );
            })}
        </InputSelect>
        <StyledSelect>
          <SelectedLabel>
            {selectedLabel !== label && selectedLabel}
          </SelectedLabel>
        </StyledSelect>
      </Fieldset>
      {
        (helpBoxAlwaysVisible || helpBoxIcon) && _helpBoxTemplate && helpBoxOpen && (
          <HelpBox template={_helpBoxTemplate} props={props} value={value} />
        )
      }
      <ValidationBar
        error={errorMessage}
        subLabel={subLabel}
        disableValidation={disableValidation}
      />
    </React.Fragment>
  );
};

export default Dropdown;
